import { Component } from 'react'
import { connect } from 'react-redux'
import SmoothCollapse from 'react-smooth-collapse'
import { updateTask } from 'state/actions'
import TaskMenu from './task-menu'


import ProfilePicture from 'components/profile/profile-picture'

import copy from 'fast-copy'

import { createSelector } from 'reselect'

import {
	getCurrentAccount,
	getCurrentUser
} from 'state/selectors'

import isEqual from 'react-fast-compare'

class TaskPeople extends Component {
	state = {}

	selectedUsersArray = []

	shouldComponentUpdate = (nextProps, nextState) => {
		const {
			peopleData,
			menuState,
			task
		} = this.props

		const taskId = task ? task.id : -1
		const newTaskId = nextProps.task ? nextProps.task.id : -2

		const hasMenuStatusChanged = menuState.currentFocusedTask == taskId || nextProps.menuState.currentFocusedTask == newTaskId

		const hasPeopleDataChanged = !isEqual(peopleData, nextProps.peopleData)

		const shouldUpdate = hasPeopleDataChanged || hasMenuStatusChanged

		return shouldUpdate
	}

	isUserIdInTask = (user, userIdsArray) => {
		let isUserIdInTask = false

		if(userIdsArray.indexOf(user.id) !== -1){
			isUserIdInTask = true
		}

		return isUserIdInTask
	}

	clickPerson = user => {
		const {
			task,
			taskUpdateCallback,
			updateTask,
			column
		} = this.props

		let userId = user.id

		let columnData = (task.column_data && task.column_data[column.id]) ? copy(task.column_data[column.id]) : []

		let activity = null

		let userIdIndexIfExists = columnData.indexOf(userId)

		if(userIdIndexIfExists !== -1){
			activity = 'REMOVE'
			columnData.splice(userIdIndexIfExists, 1)
		}else{
			activity = 'ADD'
			columnData.push(userId)
		}


		updateTask({
			...task,
			column_data: {
				...task.column_data,
				[column.id]: columnData
			}
		}, taskUpdateCallback)
	}

	clickMenu = _ => {
		const {
			isDisabled,
			menuState,
			task,
			openMenu,
			column
		} = this.props

		if(!isDisabled && openMenu){
			if(menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == task.id){
				openMenu(null)
			}else if(task){
				openMenu(column.id,task.id)
			}
		}
	}

	render() {
		const {
			menuState,
			task,
			isDisabled,
			isSingle,
			openMenu,
			peopleData,
			column
		} = this.props

		const {
			selectedUsersArray,
			allUsersArray,
			taskUsers,
			usersText
		} = peopleData

		let className = 'task-people'

		if(!selectedUsersArray.length){
			className += ' hidden'
		}

		if(isDisabled){
			className += ' disabled'
		}

		// sometimes it's optimistically loaded
		const taskId = task ? task.id : -1

		let isOpened = !!isSingle

		if(menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == taskId){
			className += ' active'

			isOpened = true
		}

		if(isSingle && isDisabled){
			className += ' single-disabled'
		}

		return(
			<a href="javascript:void(0)" className={className} onClick={this.clickMenu}>
				{ (isSingle && isDisabled) ? 
					'No people'
				: null}
				<div className="profile-picture-stack">
					{
						selectedUsersArray && selectedUsersArray.length ?
						selectedUsersArray.map((user, index) => {
							if(index > 2){
								return null
							}

							return(
								<ProfilePicture user={user} key={user.id} isTiny={true} />
							)
						})
						: null
					}
				</div>
				{ !isSingle &&
					<span>
						{ usersText ? usersText : 'Anyone' }
					</span>
				}
				{ task ?
					<div className={'smooth-collapse-container'}>
						<SmoothCollapse 
							heightTransition="0.15s ease" 
							expanded={isOpened}
							className="task-menu-collapse"
						>
							<TaskMenu 
								column={column}
								isDisabled={isDisabled} 
								hasSearch={isDisabled ? false : true} 
								isOpened={isOpened} 
								isSingle={isSingle} 
								dismissCallback={openMenu ? openMenu : _ => {}} 
								type="people" 
								menuItems={allUsersArray} 
								selectedMenuItems={taskUsers} 
								isSelectedCheck={this.isUserIdInTask} 
								selectCallback={this.clickPerson} 
								taskId={task.id} 
							/>
						</SmoothCollapse>
					</div>
				: null }
			</a>
		);
	}

}

const getPeopleData = createSelector(
	[
		state => state.account.entities.users,
		state => getCurrentUser(state),
		(_, props) => props.task,
		(_, props) => props.applicableUsers,
		(_, props) => props.column
	],
	(users, userData, task, applicableUsers, column) => {
		const selectedUsersArray = []
		const allUsersArray = (applicableUsers ? [...applicableUsers] : []).filter(Boolean)

		const taskUsers = (task && task.column_data && task.column_data[column.id]) ? task.column_data[column.id] : []

		// users arrays
		taskUsers.forEach(userId => {
			const userObject = users[userId]

			if(!userObject || !userObject.first_name){
				return
			}

			const applicableUserIfExists = allUsersArray.find(user => {
				return user.id === userId
			})

			if(!applicableUserIfExists){
				allUsersArray.push(userObject)
			}

			userObject && selectedUsersArray.push(userObject)
		})

		selectedUsersArray.sort((a, b) => {
			let firstUserName = a.first_name.toUpperCase()
			let secondUserName = b.first_name.toUpperCase()
			return (firstUserName < secondUserName) ? -1 : (firstUserName > secondUserName) ? 1 : 0
		})

		allUsersArray.sort((a, b) => {
			if(a.id === userData.id) return -1
			if(b.id === userData.id) return 1
			return 0
		})

		// copy
		let usersText = ''

		if(selectedUsersArray && selectedUsersArray.length){
			if(selectedUsersArray.find(user => {
				return user.id === userData.id
			})){
				usersText = 'Me';
			}else{
				usersText = selectedUsersArray[0].first_name;
			}

			if(selectedUsersArray.length > 1){
				usersText += ' + '+(selectedUsersArray.length - 1);
			}
		}

		return {
			selectedUsersArray,
			allUsersArray,
			taskUsers,
			usersText
		}
	}
)

const mapStateToProps = (state, ownProps) => {
  return {
	account: getCurrentAccount(state),
	peopleData: getPeopleData(state, ownProps),
    allUsers: state.account.entities.users,
  };
}

export default connect(mapStateToProps, {updateTask})(TaskPeople)
